import { CSSProperties, ReactElement, useEffect, useState } from "react";
import { IMaintenanceSAP, IPanelProps, ISAPItem } from "./types";
import { cloneObject } from "../../../../system/utils";
import RowComponent from "../../components/rowComponent";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { Checkbox, Paper } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import DeleteIcon from "@mui/icons-material/Delete";

const heatGridStyle = {
  gridTemplateColumns: "1fr 1fr"
};

const titleCellStyle = (): CSSProperties => ({
  padding: ".5em",
  alignSelf: "stretch",
  gridColumn: "1 / span 1",
  borderRadius: 5,
  background: "rgba(50, 50, 50, .3)",
  width: 150
});

const rowStyle = (ratio?: number): CSSProperties => ({
  display: "grid",
  gap: ".5em",
  gridTemplateColumns: ratio ? `${ratio * 100}% ${100 - ratio * 100}%` : "40% 60%",
  gridTemplateRows: "1fr",
  justifyContent: "stretch",
  alignContent: "stretch"
});


const MaintenanceSAPPanel = ({ value, property, onChange }: IPanelProps<IMaintenanceSAP | undefined>): ReactElement => {
  const [ checked, setChecked ] = useState<number[]>([]);

  useEffect(() => {
    if (!value) {
      onChange(property, { items: [] });
    }
  }, [value, property, onChange]);

  const onChecked = (index: number, isChecked: boolean) => {
    if (isChecked) {
      setChecked([...checked, index]);
    } else {
      setChecked(checked.filter(x => x !== index));
    }
  };

  const onAddNewItem = () => {
    const newObj = cloneObject(value ?? { items: [] });
    newObj?.items.push({ failureReported: "", notificationNr: "" });

    onChange(property, newObj);
    setChecked([]);
  };

  const onRemoveSelectedHeats = () => {
    const newObj = cloneObject(value);

    checked.sort((a, b) => b - a)
      .forEach(index =>  {
        newObj?.items.splice(index, 1);
    });

    onChange(property, newObj);
    setChecked([]);
  };


  const onChangeItem = (index: number, prop: keyof ISAPItem, newValue: string) => {
    const newObj = cloneObject(value ?? { items: [] })!;

    newObj.items[index][prop] = newValue;
    onChange(property, newObj);
  };

  return (
    <div className="display-flex-column gap-1 p-1">
      <RowComponent title="Failure Reported to Maintenance in SAP" ratio={.7} >
        <div className="display-flex-row gap-1" style={heatGridStyle}>
          <Paper elevation={0}  style={titleCellStyle()} className="display-grid">
            <div className="align-self-center justify-self-center display-flex-column">
              <strong>Notification #</strong>
            </div>
          </Paper>

          <div className="flex-grow-1 gap-1">
            <IconButton size={"small"}  color="success" onClick={onAddNewItem}>
              <AddCircleOutlineIcon/>
            </IconButton>
            <IconButton size={"small"}  color="error" onClick={onRemoveSelectedHeats} disabled={checked.length === 0}>
              <DeleteIcon/>
            </IconButton>
          </div>
        </div>
      </RowComponent>
        { value && value.items.map((item, index) => {

          return (
            <div key={`chargeWeight-${index}`} style={rowStyle(.7)}>
              <TextField
                variant="outlined"
                placeholder="to be filled..."
                value = {item.failureReported}
                fullWidth={true}
                slotProps={{ input: {
                    startAdornment: <InputAdornment position="start">
                    <Checkbox
                      style={{ width: 30 }}
                      checked={checked.includes(index)}
                      tabIndex={-1}
                      disableRipple={true} onChange={(_event, isChecked) => onChecked(index, isChecked)}/>
                  </InputAdornment>,
                }}}
                onChange={event => onChangeItem(index, "failureReported", event.target.value)}
              />
              <TextField
                variant="outlined"
                placeholder="to be filled..."
                value = {item.notificationNr}
                fullWidth={true}
                style={{ width: 150 }}
                onChange={event => onChangeItem(index, "notificationNr", event.target.value)}
              />
            </div>
          );
        })}
    </div>
  );
};

export default MaintenanceSAPPanel;